import React, { useState } from "react";
import {
  Stack,
  Typography,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AgeCalculation from "./ageCalculation";
import { Directions } from "@mui/icons-material";

function LoadingModal(props) {
  const [open, setOpen] = useState(true);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDateDay: "",
    birthDateMonth: "",
    birthDateYear: "",
    relation: "",
  });
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log(props.submitedData);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100vw",
    height: "100vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflowY: "scroll",
  };

  const handleChange = (e) => {
    console.log(e.target);
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  console.log(formData);
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          {props.submitedData.status === "waiting" && (
            <Stack
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="100%"
            >
              <CircularProgress />

              <>Submitting waiver....</>
            </Stack>
          )}

          {props.submitedData.status === "success" && (
            <Stack
              alignItems="center"
              //   justifyContent="center"
              width="100%"
              height="100%"
              sx={{ overflowY: "auto" }}
            >
              <Box
                sx={{
                  width: "300px",
                  color: "white",
                  fontSize: "20px",
                  backgroundColor: "green",
                  padding: "20px",
                  marginTop: "100px",
                  borderRadius: "10px",
                  textAlign: "center",
                }}
              >
                Waiver Completed - Thank you!
              </Box>

              <Box
                sx={{
                  //   fontSize: "12px",
                  width: "300px",
                  textAlign: "left",
                  marginTop: "20px",
                }}
              >
                Please present this comfirmation along with your ticket at the
                entry
              </Box>
              <Box
                sx={{
                  //   fontSize: "12px",
                  width: "300px",
                  textAlign: "left",
                  marginTop: "20px",
                }}
              >
                Date: {props.submitedData.data.timeStamp.slice(0, 10)}
              </Box>
              <Stack
                alignItems="center"
                justifyContent="start"
                width="300px"
                paddingTop="30px"
              >
                <Box
                  sx={{
                    color: "purple",
                    fontSize: "20px",
                    width: "300px",
                    textAlign: "center",
                    marginBottom: "20px",
                  }}
                >
                  Adult/Guardian
                </Box>
                <Box
                  sx={{
                    color: "purple",
                    fontSize: "16px",
                    width: "300px",
                    textAlign: "left",
                  }}
                >
                  Name{" "}
                </Box>
                <Box sx={{ width: "300px", textAlign: "right" }}>
                  {props.submitedData.data.firstName}{" "}
                  {props.submitedData.data.lastName}
                </Box>
                <Box
                  sx={{
                    color: "purple",
                    fontSize: "16px",
                    width: "300px",
                    textAlign: "left",
                    borderTop: "1px gray solid",
                  }}
                >
                  Age
                </Box>
                <Box
                  sx={{
                    fontSize: "16px",
                    width: "300px",
                    textAlign: "right",
                  }}
                >
                  <AgeCalculation
                    birthDate={`${props.submitedData.data.birthDateYear}-${props.submitedData.data.birthDateMonth}-${props.submitedData.data.birthDateDay} 01:45:31.123Z`}
                  />
                </Box>
                <Box
                  sx={{
                    color: "purple",
                    fontSize: "20px",
                    width: "300px",
                    textAlign: "center",
                    borderTop: "1px gray solid",
                    paddingTop: "40px",
                    marginBottom: "20px",
                  }}
                >
                  Minor(s)
                </Box>
              </Stack>
              {props.submitedData.data.minors.length > 0 ? (
                props.submitedData.data.minors.map((e) => (
                  <>
                    <Box
                      sx={{
                        color: "purple",
                        fontSize: "16px",
                        width: "300px",
                        textAlign: "left",
                      }}
                    >
                      Name
                    </Box>
                    <Box sx={{ width: "300px", textAlign: "right" }}>
                      {e.firstName} {e.lastName}
                    </Box>
                    <Box
                      sx={{
                        color: "purple",
                        fontSize: "16px",
                        width: "300px",
                        textAlign: "left",
                        borderTop: "1px black solid",
                      }}
                    >
                      Age
                    </Box>
                    <Box
                      sx={{
                        fontSize: "20px",
                        width: "300px",
                        textAlign: "right",
                      }}
                    >
                      <AgeCalculation
                        birthDate={`${e.birthDateYear}-${e.birthDateMonth}-${e.birthDateDay} 10:45:31.123Z`}
                      />
                    </Box>

                    <Box
                      sx={{
                        color: "purple",
                        fontSize: "20px",
                        width: "300px",
                        textAlign: "left",
                        borderTop: "1px black solid",
                        paddingTop: "30px",
                      }}
                    ></Box>
                  </>
                ))
              ) : (
                <></>
              )}
            </Stack>
          )}

          {/* {props.submittedData.status="success":} */}
        </Box>
      </Modal>
    </div>
  );
}

export default LoadingModal;
